import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../screen/auth/action';

import {
  SendOTPByPhoneUrl,
  SendOTPThroughExistingUserUrl,
  SendOTPToChangePhoneNumberUrl,
  VerifyOTPToChangePhoneNumberUrl,
  VerifyToChangePhoneNumberOfCompanyOrUserUrl,
  addRolePermissionUrl,
  addUserThroughExistingCompanyUrl,
  deleteEmployeeUrl,
  deleteUserFirmsUrl,
  deleteUserUrl,
  getEmployeesUrl,
  getUserFirmsUrl,
  updateActiveStatusOfDealershipCoUrl,
  updateFirmInfoUrl,
  updateUserInfoUrl,
} from '../url';

export const updateUserInfoAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .put(updateUserInfoUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const DeleteUser = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(deleteUserUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const getUserFirmsAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getUserFirmsUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const deleteFirmAction = async ({ company_id }) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .delete(
        `${deleteUserFirmsUrl()}?company_id=${company_id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const updateFirmInfoAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .put(updateFirmInfoUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const updateActiveStatusOfDealershipCoAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .put(updateActiveStatusOfDealershipCoUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getEmployeesAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getEmployeesUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const SendOTPThroughExistingUser = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${SendOTPThroughExistingUserUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const addUserThroughExistingCompany = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${addUserThroughExistingCompanyUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const deleteEmployeeAction = async ({ company_user_id, company_id }) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .delete(
        `${deleteEmployeeUrl()}?company_user_id=${company_user_id}&company_id=${company_id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const SendOTPByPhoneNow = async (phone_number) => {
  return new Promise(async (next) => {
    await axios
      .get(`${SendOTPByPhoneUrl()}?phone_number=${phone_number}`)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const SendOTPToChangePhoneNumber = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${SendOTPToChangePhoneNumberUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const VerifyOTPToChangePhoneNumber = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${VerifyOTPToChangePhoneNumberUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const VerifyToChangePhoneNumberOfCompanyOrUser = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${VerifyToChangePhoneNumberOfCompanyOrUserUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const addRolePermissionAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${addRolePermissionUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
